import Layout from '@/layout';

const sectionPage = () => import('@/views/cms/SectionList.vue');

export default [
  {
    path: '/cms',
    component: Layout,
    redirect: '/cms/site',
    name: 'cms',
    meta: {
      icon: 'Monitor',
      title: '官网 CMS',
    },
    children: [
      {
        path: 'site',
        component: () => import('@/views/cms/SiteSettings.vue'),
        name: 'cms-site',
        meta: {
          icon: 'Setting',
          title: '站点设置',
        },
      },
      {
        path: 'banner',
        component: () => import('@/views/cms/BannerList.vue'),
        name: 'cms-banner',
        meta: {
          icon: 'Picture',
          title: 'Banner 管理',
        },
      },
      {
        path: 'service',
        component: sectionPage,
        name: 'cms-service',
        meta: {
          icon: 'Goods',
          title: '制造服务',
          sectionType: 'service',
        },
      },
      {
        path: 'stat',
        component: sectionPage,
        name: 'cms-stat',
        meta: {
          icon: 'DataLine',
          title: '数据统计',
          sectionType: 'stat',
        },
      },
      {
        path: 'tool',
        component: sectionPage,
        name: 'cms-tool',
        meta: {
          icon: 'SetUp',
          title: '智能工具',
          sectionType: 'tool',
        },
      },
      {
        path: 'testimonial',
        component: sectionPage,
        name: 'cms-testimonial',
        meta: {
          icon: 'ChatDotRound',
          title: '客户评价',
          sectionType: 'testimonial',
        },
      },
      {
        path: 'factory',
        component: sectionPage,
        name: 'cms-factory',
        meta: {
          icon: 'OfficeBuilding',
          title: '工厂展示',
          sectionType: 'factory',
        },
      },
      {
        path: 'platform',
        component: sectionPage,
        name: 'cms-platform',
        meta: {
          icon: 'Platform',
          title: '平台能力',
          sectionType: 'platform',
        },
      },
      {
        path: 'process',
        component: sectionPage,
        name: 'cms-process',
        meta: {
          icon: 'Guide',
          title: '合作流程',
          sectionType: 'process',
        },
      },
      {
        path: 'quality',
        component: sectionPage,
        name: 'cms-quality',
        meta: {
          icon: 'Medal',
          title: '品质保障',
          sectionType: 'quality',
        },
      },
      {
        path: 'faq',
        component: sectionPage,
        name: 'cms-faq',
        meta: {
          icon: 'QuestionFilled',
          title: '常见问题',
          sectionType: 'faq',
        },
      },
      {
        path: 'team',
        component: sectionPage,
        name: 'cms-team',
        meta: {
          icon: 'User',
          title: '团队成员',
          sectionType: 'team',
        },
      },
      {
        path: 'article',
        component: () => import('@/views/cms/ArticleList.vue'),
        name: 'cms-article',
        meta: {
          icon: 'Document',
          title: '文章管理',
        },
      },
      {
        path: 'nav',
        component: () => import('@/views/cms/NavList.vue'),
        name: 'cms-nav',
        meta: {
          icon: 'Menu',
          title: '导航管理',
        },
      },
      {
        path: 'contact',
        component: () => import('@/views/cms/ContactList.vue'),
        name: 'cms-contact',
        meta: {
          icon: 'Message',
          title: '留言管理',
        },
      },
    ],
  },
];
